import { render, staticRenderFns } from "./Aftergroup.vue?vue&type=template&id=4370e42c&scoped=true"
import script from "./Aftergroup.vue?vue&type=script&lang=ts"
export * from "./Aftergroup.vue?vue&type=script&lang=ts"
import style0 from "./Aftergroup.vue?vue&type=style&index=0&id=4370e42c&prod&lang=css"
import style1 from "./Aftergroup.vue?vue&type=style&index=1&id=4370e42c&prod&lang=less&scoped=true"
import style2 from "./Aftergroup.vue?vue&type=style&index=2&id=4370e42c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4370e42c",
  null
  
)

export default component.exports